<template>
  <div>
    <div id="components-form-demo-advanced-search">
      <a-form layout="inline" class="ant-advanced-search-form">
        <a-row>
          <a-col :span="6">
            <a-form-item label="活动名称">
              <a-input size="small" v-model="queryParam.query_name_like" placeholder="活动名称" />
            </a-form-item>
          </a-col>

          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden', } || {} "
            >
              <a-button size="small" type="primary" @click="reloadTable">查询</a-button>
              <a-button style="margin-left: 8px" size="small" @click="queryParamRest">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <p></p>
    <div class="table-operations">
      <a-button size="small" type="primary" @click="goToAdd">添加</a-button>
      <p></p>
    </div>
    <a-table
      ref="table"
      bordered
      :columns="columns"
      rowKey="id"
      :dataSource="data"
      :pagination="pagination"
      :pageSizeOptions="pagination.pageSizeOptions"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a-divider type="vertical" />
        <a-button size="small" @click="goToUpdate(record.id)">修改</a-button>
        <a-divider type="vertical" />
        <a-button size="small" type="danger" @click="deleteById(record.id)">删除</a-button>
        <a-divider type="vertical" />
        <a-button size="small" @click="goToAddProduct(record.id)">添加活动商品</a-button>
      </span>
    </a-table>
  </div>
</template>
<script>
export default {
  name: "eventIndex",
  mounted() {},
  created() {
    this.queryParamRest();
  },
  data() {
    return {
      advanced: false,
      queryParam: {},
      data: [], //渲染表格数据
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        current: 1,
        defaultCurrent: 1,
        pageSize: 10,
        defaultPageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `Total ${total} items`
      },
      loading: false,
      columns: [
        {
          title: "活动名称",
          dataIndex: "name",
          sorter: true
        },
        {
          title: "开始时间",
          dataIndex: "startTime"
        },
        {
          title: "结束时间",
          dataIndex: "endTime"
        },

        {
          title: "说明",
          dataIndex: "note"
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.fetch(
        this.$http.initParams(pagination, filters, sorter, this.queryParam)
      );
    },
    fetch(params = {}) {
      this.loading = true;
      this.$http.get("/api/1.0/event/page", params).then(res => {
        const data = res.data;
        this.data = data.records;
        const pagination = { ...this.pagination };
        pagination.total = data.total;
        pagination.pageSize = data.size;
        pagination.current = data.current;
        this.pagination = pagination;
      });
      this.loading = false;
    },
    onShowSizeChange: () => {
      this.pagination.pageSize = pageSize;
    },

    queryParamRest() {
      this.queryParam = {};
      this.reloadTable();
    },
    reloadTable() {
      this.handleTableChange(this.pagination, null, null, this.queryParam);
    },
    deleteById: function(id) {
      this.$http.get("/api/1.0/event/delete/" + id).then(res => {
        this.reloadTable();
      });
    },
    goToAdd() {
      this.$router.push({
        path: "/event/add"
      });
    },
    goToUpdate(id) {
      this.$router.push({
        path: "/event/update/" + id
      });
    },
    goToAddProduct(id) {
      this.$router.push({
        path: "/event/add/product/" + id
      });
    },

    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    updateProduct(params) {
      this.$http.post("/api/1.0/event/update", params).then(res => {
        if (res.code === 200) {
          this.$message.info("更新成功");
        }
      });
    }
  }
};
</script>

<style scoped>
.ant-advanced-search-form .ant-form-item {
  margin-bottom: 0px;
}
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-advanced-search-form {
  padding: 12px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
</style>